<mat-dialog-content class="mat-typography">
  <div class="payment-content">
    <div class="icon">
      <mat-icon class="success-color">check_circle</mat-icon>
    </div>
    <div class="payment-title">{{ 'Payment.ThankYou' | translate }}</div>
    <div class="message">
      <div class="">
        {{ 'Payment.ConfirmationEmail' | translate }}
      </div>
      <div class="">
        {{ 'Payment.Enjoy' | translate }}
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>
    {{ 'Buttons.Close' | translate }}
  </button>
</mat-dialog-actions>
